export default "__VITE_ASSET__90a33dfe__"